import {useMapMarkersData} from '@widgets/area-dashboard'
import {AxiosError} from 'axios'
import {useCallback} from 'react'
import {useNavigate} from 'react-router'

import {handleError} from '../../shared/helpers'

export const useHrocMapMarkersData = (locationId?: string) => {
  const navigate = useNavigate()
  const onError = useCallback((error: AxiosError) => handleError(error, navigate), [navigate])

  return useMapMarkersData(locationId, {onError})
}
